/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
  <div class="team-chunk">
    <h1>{{$t("about.team")}}</h1>
    <div class="content-wrap">
      <div class="desc-wrap" v-for="item in leaderList" @click="onClick(item)">
        <div class="img cell">
          <img :src="item.icon">
          <span class="note"></span>
        </div>
        <p class="leader">
          <span>{{item.leaderName}}</span>
        </p>
        <div class="cell"></div>
        <p class="desc"><span>{{item.department ?item.department: ''}}</span><span>{{item.position}}</span></p>
      </div>
    </div>
    <TeamDetailModal v-model="isShow" :teamDetail="teamDetail"></TeamDetailModal>
  </div>
</template>

<script>
import { GetLeaderList } from '../../../api/web';
import TeamDetailModal from './team-detail-modal'

export default {
  name: "team-chunk",
  components: { TeamDetailModal },
  data() {
    return {
      leaderList: [
        {
          icon: "",
          leaderName: "wangxiao",
          department: "it"
        },
        {
          icon: "",
          leaderName: "wangxiao",
          department: "it"
        },
        {
          icon: "",
          leaderName: "wangxiao",
          department: "it"
        },
        {
          icon: "",
          leaderName: "wangxiao",
          department: "it"
        },
        {
          icon: "",
          leaderName: "wangxiao",
          department: "it"
        }
      ],
      isShow: false,
      teamDetail: {}
    }
  },
  methods: {
    init() {
      let _params = {
        companyId: 2,
        pageNum: 1,
        pageSize: 100
      };
      GetLeaderList(_params).then(res => {
        if (res.status) {
          this.leaderList = res.data.dataList;
        }
      })
    },
    onClick(item) {
      this.isShow = true;
      this.teamDetail = item
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import "../../../style/constant";

.team-chunk {
  margin: 0 auto;
  width: @page-width;
  padding: 100px 0;

  .content-wrap {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;

    .desc-wrap {
      width: 300px;
      height: 260px;
      overflow: hidden;
      // text-align: center;
      background: #fbfbfb;
      display: flex;
      flex-wrap: wrap;
      .cell {
        width: 128px;
        height: 128px;
      }
      img {
        cursor: pointer;
        object-fit: cover;
      }
      .img {
        position: relative;
        .note {
          width: 28px;
          height: 28px;
          background: #394f9a;
          position: absolute;
          right: 0px;
          bottom: 0px;
        }
      }
      .leader {
        width: 172px;
        color: #435ba1;
        position: relative;
        span {
          position: absolute;
          left: 10px;
          bottom: 0;
        }
      }
      @media screen and (min-width: 320px) and (max-width: 480px) {
        .leader {
          width: 190px;
        }
      }
      .desc {
        width: 162px;
        font-size: 15px;
        padding: 10px 0 0 10px;
        span {
          display: block;
        }
      }
      &:hover {
        background: #f2f3f5;
        .note {
          background: #e76c5e;
        }
      }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      .desc-wrap {
        height: 260px;
        width: 100%;
        .desc {
          font-size: 14px;
        }
      }
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .team-chunk {
    width: 90%;
    padding: 60px 0;
    .content-wrap {
      margin: 0px auto;
      padding: 10px 0;
    }
  }
}
</style>